<template>
  <div class="web-page">
    <slot name="default"></slot>
  </div>
</template>

<script>

export default {

}

</script>

<style scoped lang="scss">

.web-page {
  width: 100%;
  height: 100%;
}

</style>